// Registration referral-code (?code=) persistence.
//
// Goal: when a visitor lands on the registration page (or any page) with a
// ?code=<value>, remember it so every "Register" link keeps carrying it until
// the visitor actually logs in or registers.
//
// Flow:
//   1. Clear-on-auth: if the customer is already logged in / has just
//      registered (the <body> carries the `customer_login` class set by
//      layout/theme.liquid when {% if customer %}), delete the cookie and stop.
//      Shopify hosts the login/registration itself, so the first storefront
//      page load after auth is where we reliably clear the code.
//   2. Capture: otherwise, if the URL has ?code=<value>, (re)write it to a
//      30-day first-party cookie (last touch wins).
//   3. Decorate: append ?code=<value> to every Register link (/pages/register)
//      using whatever we hold (URL or cookie), preserving any existing query
//      string and never clobbering a code already on the link.
//
// The cookie stores only the referral code (e.g. "save50") — no PII.

(function () {
  var COOKIE_NAME = 'calroy_ref_code';
  var COOKIE_DAYS = 30;

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function writeCookie(name, value, days) {
    var expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie =
      name +
      '=' +
      encodeURIComponent(value) +
      '; expires=' +
      expires.toUTCString() +
      '; path=/; SameSite=Lax';
  }

  function deleteCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax';
  }

  // 1. Clear once the visitor is logged in / registered, then stop.
  var body = document.body;
  if (body && body.classList.contains('customer_login')) {
    deleteCookie(COOKIE_NAME);
    return;
  }

  // 2. Capture / refresh from the URL (last touch).
  var urlCode = (new URLSearchParams(window.location.search).get('code') || '').trim();
  if (urlCode) {
    writeCookie(COOKIE_NAME, urlCode, COOKIE_DAYS);
  }

  // 3. Decorate Register links from whatever attribution we currently hold.
  var code = urlCode || readCookie(COOKIE_NAME);
  if (!code) return;

  var SELECTOR = 'a[href*="/pages/register"]';
  // Match exactly the register page (optionally locale-prefixed / trailing
  // slash) — not siblings like /pages/register-info.
  var REGISTER_PATH = /\/pages\/register\/?$/;

  // If we're already on the register page without a code in the URL, reflect the
  // stored code into the current URL (in place, no reload) so the registration
  // form on this page can read ?code=. Runs early (head defer), before the
  // form's own load-time logic reads location.search.
  if (!urlCode && REGISTER_PATH.test(window.location.pathname)) {
    var here = new URL(window.location.href);
    here.searchParams.set('code', code);
    window.history.replaceState(null, '', here.pathname + here.search + here.hash);
  }

  function decorateLink(a) {
    var href = a.getAttribute('href');
    if (!href) return;

    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (e) {
      return;
    }

    // Same-origin register links only.
    if (url.origin !== window.location.origin) return;
    if (!REGISTER_PATH.test(url.pathname)) return;

    // Don't clobber a code already present on the link.
    if (url.searchParams.get('code')) return;

    url.searchParams.set('code', code);
    a.setAttribute('href', url.pathname + url.search + url.hash);
  }

  function decorateWithin(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches && node.matches(SELECTOR)) decorateLink(node);
    if (node.querySelectorAll) {
      node.querySelectorAll(SELECTOR).forEach(decorateLink);
    }
  }

  function decorateAll() {
    decorateWithin(document.body || document.documentElement);
  }

  // Re-decorate links added, replaced, or patched after load. The theme uses
  // view transitions / morph and section hydration (e.g. the header re-hydrates
  // itself on load), which can (re)render or href-patch the Register links in
  // the menu and drawer — so we watch both childList (new nodes) and the href
  // attribute (patched nodes). No infinite loop: once a link carries the code,
  // decorateLink() returns early, so our own rewrite doesn't re-trigger.
  function startObserver() {
    if (!window.MutationObserver) return;
    var target = document.body || document.documentElement;
    if (!target) return;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes') {
          decorateLink(m.target);
          continue;
        }
        var added = m.addedNodes;
        for (var j = 0; j < added.length; j++) {
          decorateWithin(added[j]);
        }
      }
    }).observe(target, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href'],
    });
  }

  function init() {
    decorateAll();
    startObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
